var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixDevcenterAppInstanceV1AppInstance from '@wix/ambassador-devcenter-app-instance-v1-app-instance/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var PaymentCycle;
(function (PaymentCycle) {
    PaymentCycle["NO_CYCLE"] = "NO_CYCLE";
    PaymentCycle["MONTHLY"] = "MONTHLY";
    PaymentCycle["YEARLY"] = "YEARLY";
    PaymentCycle["ONE_TIME"] = "ONE_TIME";
    PaymentCycle["TWO_YEARS"] = "TWO_YEARS";
    PaymentCycle["THREE_YEARS"] = "THREE_YEARS";
    PaymentCycle["FOUR_YEARS"] = "FOUR_YEARS";
    PaymentCycle["FIVE_YEARS"] = "FIVE_YEARS";
})(PaymentCycle || (PaymentCycle = {}));
export var FreeTrialStatus;
(function (FreeTrialStatus) {
    FreeTrialStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    FreeTrialStatus["IN_PROGRESS"] = "IN_PROGRESS";
    FreeTrialStatus["ENDED"] = "ENDED";
    FreeTrialStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(FreeTrialStatus || (FreeTrialStatus = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _getAppInstanceByInstanceIdRequest = {};
const _getAppInstanceRequest = {};
const _getAppInstanceResponse = {};
/**
 * Retrieves data about the instance of your app that's installed on the Wix
 * site and the site itself.
 *
 *
 * You don't have to explicitly pass an identifier for the Wix site as part of
 * the request, since this information is taken automatically from the context.
 *
 * In case you want `site.ownerInfo` to be included in the response, you must
 * have the __Read Site Owner Email__ permission scope in addition to
 * __WIX_DEVELOPERS.MANAGE_APP_INSTANCE__.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function getAppInstance() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getAppInstanceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getAppInstanceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['instance']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixDevcenterAppInstanceV1AppInstance.getAppInstance(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param instanceId - ID of the app instance to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField instanceId
 * @adminMethod
 */
export function getAppInstanceByInstanceId(instanceId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { instanceId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getAppInstanceByInstanceIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getAppInstanceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['instance']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([instanceId]);
        const reqOpts = ambassadorWixDevcenterAppInstanceV1AppInstance.getAppInstanceByInstanceId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'instanceId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=devcenter-app-instance-v1-app-instance.universal.js.map